import { ZoneTableDTO } from '../../../Domain/DTO/ZoneTableDTO';

export interface ILocalityHelperProps{
    AllZones: Array<ZoneTableDTO>
    SelectedZone: ZoneTableDTO
}

export const InitialLocalityHelperProps: ILocalityHelperProps = { AllZones: [], SelectedZone: undefined};